import { useState } from "react";
import Modal from "../../components/common/Modal";
import CrudForm from "../../components/common/crud/CrudForm";
import shippingLineService from "../../services/shippingLineService";
import alertService from "../../utils/alertService";
import { normalizeApiError } from "../../utils/apiError";

const shippingLineFormSchema = [
  {
    name: "shippingLineName",
    label: "Shipping Line Name",
    type: "text",
    placeholder: "e.g. Maersk",
    validation: {
      required: true,
      minLength: 2,
      maxLength: 100,
    },
  },
  {
    name: "isActive",
    label: "Is Active",
    type: "checkbox",
    defaultValue: true,
  },
];

function ShippingLineCreateModal({ isOpen, onClose, onSuccess }) {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (values) => {
    setIsSubmitting(true);
    try {
      await shippingLineService.createShippingLine(values);
      alertService.success("Shipping Line created successfully.");
      onSuccess?.();
      onClose();
    } catch (err) {
      alertService.error(normalizeApiError(err).message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Add New Shipping Line">
      <CrudForm
        mode="create"
        schema={shippingLineFormSchema}
        initialValues={{ isActive: true }}
        isSubmitting={isSubmitting}
        onSubmit={handleSubmit}
        onCancel={onClose}
      />
    </Modal>
  );
}

export default ShippingLineCreateModal;
